import React from 'react'
import { Link } from 'gatsby'
import user1 from '../../assets/images/user1.jpg'

const BlogCard = ({ posts, currentPage, numPages }) => {
  if (!posts) {
    return null
  }

  const isFirst = currentPage === 1
  const isLast = currentPage === numPages
  const prevPage =
    currentPage - 1 === 1 ? '/blog' : '/blog/' + (currentPage - 1).toString()
  const nextPage = '/blog/' + (currentPage + 1).toString()

  return (
    <div className="blog-area ptb-100">
      <div className="container">
        <div className="row">
          {posts.map((post, index) => {
            return (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="single-blog-post bg-fffbf5">
                  <div className="post-image">
                    <Link to={`/` + post.node.slug}>
                      <img
                        src={post.node.featured.fluid.srcWebp}
                        alt={post.node.title}
                      />
                    </Link>
                  </div>

                  <div className="post-content">
                    <ul className="post-meta d-flex justify-content-between align-items-center">
                      <li>
                        <div className="post-author d-flex align-items-center">
                          <img
                            src={user1}
                            className="rounded-circle"
                            alt="Sirichai"
                          />
                          <span>Sirichai</span>
                        </div>
                      </li>
                      <li>
                        <i className="flaticon-calendar"></i>{' '}
                        {post.node.createdAt}
                      </li>
                    </ul>
                    <h3>
                      <Link to={`/` + post.node.slug}>{post.node.title}</Link>
                    </h3>
                  </div>
                </div>
              </div>
            )
          })}

          {numPages > 1 && (
            <div className="col-lg-12 col-md-12">
              <div className="pagination-area text-center">
                {!isFirst && (
                  <Link
                    to={prevPage}
                    rel="prev"
                    className="prev page-numbers"
                    aria-label="prev"
                  >
                    <i className="bx bx-chevrons-left"></i>
                  </Link>
                )}

                {Array.from({ length: numPages }, (_, i) => (
                  <span key={i}>
                    {i + 1 === currentPage ? (
                      <span
                        className="page-numbers current"
                        aria-current="page"
                      >
                        {i + 1}
                      </span>
                    ) : (
                      <Link
                        to={`/blog${i === 0 ? '' : '/' + (i + 1)}`}
                        className="page-numbers"
                      >
                        {i + 1}
                      </Link>
                    )}
                  </span>
                ))}

                {!isLast && (
                  <Link
                    to={nextPage}
                    rel="next"
                    className="next page-numbers"
                    aria-label="next"
                  >
                    <i className="bx bx-chevrons-right"></i>
                  </Link>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default BlogCard
